import { render, staticRenderFns } from "./SubjectRecord.vue?vue&type=template&id=ea7323ac&scoped=true"
import script from "./SubjectRecord.vue?vue&type=script&lang=ts"
export * from "./SubjectRecord.vue?vue&type=script&lang=ts"
import style0 from "./SubjectRecord.vue?vue&type=style&index=0&id=ea7323ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7323ac",
  null
  
)

export default component.exports